const config = {
    server_ip: "http://201.238.213.114:2280/sketch_search",
    //server_ip: "http://192.168.20.66:4000",
}
  
export default config;
  
